import isNonEmptyString from './isNonEmptyString';
import readRedesignRootAttribute from './readRedesignRootAttribute';

const SERVER_PLACEMENT_ATTRIBUTE = 'data-redesign-organizer-tags-placed';

function readTrackerNames(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value)) {
        return {};
    }

    return Object.entries(value).reduce((names, [trackingId, trackerName]) => {
        if (!isNonEmptyString(trackingId) || !isNonEmptyString(trackerName)) {
            return names;
        }

        return { ...names, [trackingId]: trackerName };
    }, {});
}

function readStringList(value) {
    return Array.isArray(value) ? value.filter(isNonEmptyString) : [];
}

function readRedesignOrganizerTagPlacement() {
    const placement = readRedesignRootAttribute(SERVER_PLACEMENT_ATTRIBUTE);

    if (!placement || typeof placement !== 'object' || Array.isArray(placement)) {
        return {
            placedTagKeys: [],
            placedEventKeys: [],
            eventKeySpellings: [],
            analyticsTrackerNames: {},
        };
    }

    return {
        placedTagKeys: readStringList(placement.placedTagKeys),
        placedEventKeys: readStringList(placement.placedEventKeys),
        eventKeySpellings: readStringList(placement.eventKeySpellings),
        analyticsTrackerNames: readTrackerNames(placement.analyticsTrackerNames),
    };
}

export default readRedesignOrganizerTagPlacement;
export { SERVER_PLACEMENT_ATTRIBUTE };
